<template>
  <div id="noproject">
    <div style="background:#fff;width: 100%;height:100%">
      <div class="box">
        <img :src="zanwu" />
        <p style="font-size: 16px; color: #000; margin-top: 36px;text-align: center;"> 暂无项目 </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Noproject",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png")
    };
  }
};
</script>

<style lang="scss" scoped>
#noproject {
  height: 100%;
  background: #eff1f6;
  padding: 14px;
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
}
</style>
